module.exports = __webpack_public_path__ + "img/whatsapp.53855e4a.svg";